import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  CHALLENGES_ADD_PATH,
  CHALLENGES_PATH,
  CHALLENGES_UPDATE_PATH,
} from "utils/constants/paths";

const Challenges = Loadable(React.lazy(() => import("./View")));
const ChallengesAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const ChallengesRoute: IRouteItem = {
  path: CHALLENGES_PATH,
  iconName: "Cup",
  element: React.createElement(Challenges),
  name: "Challenges",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: CHALLENGES_ADD_PATH,
      element: React.createElement(ChallengesAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: CHALLENGES_UPDATE_PATH,
      element: React.createElement(ChallengesAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
